/**
 * @generated SignedSource<<15280667f706316750b55d64796fb790>>
 * @relayHash c197bbece789e4cb329e128453687570
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
